exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dsh-bimmodel>section>img {\n  height: 100%;\n  width: 100%;\n}\n", ""]);
